<template>
  <tab-item-template>
    <template #toolbar-items>
      <el-tooltip content="新規カレンダ作成" placement="bottom" v-if="isEditable">
        <v-btn icon @click="openCreateDialog">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </el-tooltip>
    </template>

    <calendar-table
        :calendars="calendars"
        @openDeleteDialog="openDeleteDialog"
        @openUpdateDialog="openUpdateDialog">
    </calendar-table>

    <!-- 作成ダイアログ -->
    <simple-dialog
        v-model="dialogCreate.visible"
        title-text="カレンダ作成"
        @close="closeCreateDialog"
        @apply="createCalendar">
      <calendar-form
          v-model="dialogCreate.form"
          @export="dialogCreate.export = $event">
      </calendar-form>
    </simple-dialog>

    <!-- 更新ダイアログ -->
    <simple-dialog
        v-model="dialogUpdate.visible"
        title-text="カレンダ編集"
        @close="closeUpdateDialog"
        @apply="updateCalendar">
      <calendar-form
          v-model="dialogUpdate.form"
          @export="dialogUpdate.export = $event">
      </calendar-form>
    </simple-dialog>

    <!-- 削除ダイアログ -->
    <simple-dialog
        v-model="dialogDelete.visible"
        title-text="カレンダ削除"
        title-color="delete"
        apply-text="削除"
        :header-text="`カレンダ ${dialogDelete.form && dialogDelete.form.name} を削除します。本当によろしいですか？`"
        @close="closeDeleteDialog"
        @apply="deleteCalendar">
      <calendar-form
          v-model="dialogDelete.form"
          readonly>
      </calendar-form>
    </simple-dialog>
  </tab-item-template>
</template>

<script>
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import CalendarTable from "@/components/pages/implementation/TerminalImplementationList/CalendarTable.vue";
import CalendarForm from "@/components/pages/implementation/TerminalImplementationList/CalendarForm.vue";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import {mapGetters, mapMutations, mapState} from "vuex";
import {DateTime} from "luxon";
import CalendarView from "@/components/pages/implementation/TerminalImplementationList/CalendarView";

export default {
  name: "CalendarListTab",
  components: {
    TabItemTemplate,
    SimpleDialog,
    CalendarTable,
    CalendarForm
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin
  ],
  data() {
    return {
      dialogCreate: {
        visible: false,
        form: null,
        export: null,
      },
      dialogUpdate: {
        visible: false,
        form: null,
        export: null,
      },
      dialogDelete: {
        visible: false,
        form: null
      },
    }
  },
  computed: {
    ...mapState('hcs/calendar', ['calendars']),
    ...mapGetters({
      account: 'hcs/account'
    }),
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    load() {
      return this.$store.dispatch('hcs/calendar/findList', { q: { terminalIdEq: this.account.user?.terminal?.id } })
    },
    openCreateDialog() {
      this.dialogCreate = {
        visible: true,
        form: this.defaultForm(),
        export: {},
      };
    },
    closeCreateDialog() {
      this.dialogCreate.visible = false;
    },
    openUpdateDialog(calendar) {
      this.dialogUpdate = {
        visible: true,
        form: calendar,
        export: calendar,
      };
    },
    closeUpdateDialog() {
      this.dialogUpdate.visible = false;
    },
    openDeleteDialog(calendar) {
      this.dialogDelete = {
        visible: true,
        form: calendar
      }
    },
    closeDeleteDialog() {
      this.dialogDelete.visible = false;
    },
    defaultForm() {
      return {
        terminalId: this.account.user.terminal.id,
        name: null,
        description: null,
        startDate: DateTime.now().toISO({includeOffset: false}),
        recurrenceTimeZone: CalendarView.SYSTEM_TIMEZONE,
        intervalType: null,
        interval: 0,
        daysOfWeek: null,
        weeksOfMonth: null,
        endType: 'none',
        numberOfOccurrences: null,
      }
    },
    createCalendar() {
      this.showSnackbar({
        message: 'カレンダを作成中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/calendar/create', this.dialogCreate.export)
          .then(() => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `作成に成功しました`
            });
          })
          .catch(() => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `作成に失敗しました`
            });
          });
    },
    updateCalendar() {
      this.showSnackbar({
        message: 'カレンダを保存中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/calendar/update', this.dialogUpdate.export)
          .then(response => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `保存に成功しました`
            });
          })
          .catch(() => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `保存に失敗しました`
            });
          });
    },
    deleteCalendar() {
      this.showSnackbar({
        message: 'カレンダを削除中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/calendar/delete', this.dialogDelete.form.id)
          .then(() => {
            this.$store.commit({
              type: 'showSnackbar',
              message: `カレンダが削除されました`
            });
          })
          .catch(() => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `カレンダの削除に失敗しました`
            });
          });
    }
  }
}
</script>
